import type {ReactAction} from '@netx/core/bootstrap';
import {performLegacyAction} from '@netx/core-next/utils/actions';
import {faList} from '@netx/core-icons';
import {UserActionLabel} from '../locales';

export const userActionAttributeSetsIcon = faList;

/**
 * Route to user attribute sets
 * @param params
 * @returns Action
 */
export const userActionAttributeSets = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-attribute-sets',
	cb: () => performLegacyAction('user:attributeSets:route'),
	icon: userActionAttributeSetsIcon,
	get label() {
		return UserActionLabel.ATTRIBUTE_SETS;
	},
	routeMatch: /^user\/attributeSets(\/?)/,
	...params,
});

export default userActionAttributeSets;
